// Focus Set model types

export type ProblemSet = "new" | "focus" | "old";

export type AnswerResult = "correct" | "wrong";

export type PresentedType = "easy" | "hard" | "random" | "retry";

export interface SessionProblem {
  problemId: string;
  problemText: string;
  groupId: string;
  type: PresentedType;
  pCorrect: number;
}

export interface FocusSetStatus {
  newCount: number;
  focusCount: number;
  oldCount: number;
  focusCorrectCount: number;
  masteryPercent: number;
  mastered: boolean;
}

export interface NextProblemResult {
  problem: SessionProblem | null;
  done: boolean;
  mastered: boolean;
  message?: string;
  focusStatus: FocusSetStatus;
}
